import { match, P } from 'ts-pattern';
import { SURVEY_SCORE_GROUPS, SurveyScoreGroup } from '../../constants';

export const getSurveyScoreGroup = (
  scorePercentage: number,
): SurveyScoreGroup => {
  return match({ score: scorePercentage })
    .with(
      {
        score: P.when((_score) => _score >= SURVEY_SCORE_GROUPS.GREEN.minValue),
      },
      () => SURVEY_SCORE_GROUPS.GREEN,
    )
    .with(
      {
        score: P.when(
          (_score) => _score >= SURVEY_SCORE_GROUPS.YELLOW.minValue,
        ),
      },
      () => SURVEY_SCORE_GROUPS.YELLOW,
    )
    .with(
      { score: P.when((_score) => _score >= SURVEY_SCORE_GROUPS.RED.minValue) },
      () => SURVEY_SCORE_GROUPS.RED,
    )
    .otherwise(() => SURVEY_SCORE_GROUPS.RED);
};
